import React from "react";
import GlobalButton from "../../../shared/utils/GlobalButton";

const ProductMediaModal = ({ isOpen, onClose, products = [] }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        className="flex max-h-[90vh] w-full max-w-5xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b px-6 py-4">
          <div>
            <h2 className="text-xl font-semibold text-gray-800">
              Product Media
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              View uploaded images and videos
            </p>
          </div>

          {/* <button
            onClick={onClose}
            className="rounded-lg px-3 py-1 text-2xl text-gray-500 hover:bg-gray-100 hover:text-gray-800"
          >
            &times;
          </button> */}
        </div>

        {/* Product Media */}
        <div className="space-y-6 overflow-y-auto p-6">
          {products.length > 0 ? (
            products.map((product, index) => {
              const images = product.images || [];
              const videos = product.videos || [];
              const hasMedia = images.length > 0 || videos.length > 0;

              return (
                <div
                  key={`${product.productName}-${index}`}
                  className="rounded-lg border border-gray-200 p-4"
                >
                  <h3 className="mb-3 font-semibold text-gray-800">
                    {product.productName}
                  </h3>

                  {hasMedia ? (
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
                      {images.map((url, imageIndex) => (
                        <>
                          <div key={`image-${imageIndex}`} className="w-full">
                            <a
                              href={url}
                              target="_blank"
                              rel="noreferrer"
                              title="Open image in new tab"
                            >
                              <img
                                src={url}
                                alt={`${product.productName} ${imageIndex + 1}`}
                                className="h-48 w-full rounded-lg  object-contain  transition hover:opacity-70"
                                loading="lazy"
                              />
                            </a>
                            <p className="text-center text-xs text-gray-500">
                              Image {imageIndex + 1}
                            </p>
                          </div>
                        </>
                      ))}

                      {videos.map((url, videoIndex) => (
                        <div key={`video-${videoIndex}`}>
                          <video
                            src={url}
                            controls
                            preload="metadata"
                            className="h-48 w-full rounded-lg border bg-black object-contain"
                          />
                          <p className="mt-1 text-xs text-gray-500">
                            Video {videoIndex + 1}
                          </p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="rounded-lg bg-gray-50 px-4 py-6 text-center text-sm text-gray-500">
                      No media uploaded for this product.
                    </p>
                  )}
                </div>
              );
            })
          ) : (
            <p className="py-8 text-center text-gray-500">No products found.</p>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end border-t px-6 py-4">
          <div className="w-24">
            <GlobalButton
              type="submit"
              variant="primary"
              size="medium"
              onClick={onClose}
            >
              Close
            </GlobalButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductMediaModal;
